module.exports = __webpack_public_path__ + "img/image-404.52d08f95.jpg";